// extracted by mini-css-extract-plugin
export var modal = "styles-module--modal--24468";
export var modalClose = "styles-module--modal-close--bde7c";
export var modalLogo = "styles-module--modal-logo--1b22f";
export var overlay = "styles-module--overlay--af1fa";
export var textLogo = "styles-module--text-logo--ca6eb";
export var textLogoBlack = "styles-module--text-logo-black--a80a2";
export var textLogoYellow = "styles-module--text-logo-yellow--a9284";